import { render, staticRenderFns } from "./IncompleteContactsExplanation.vue?vue&type=template&id=54cbd0f5&"
import script from "./IncompleteContactsExplanation.vue?vue&type=script&lang=js&"
export * from "./IncompleteContactsExplanation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports